import React from "react";

const TagPopupHeader = props => {
  const { showOptions, closeAction, setShowOptions } = props;

  return (
    <>
      {showOptions && (
        <div
          className="transparentOverlay"
          onClick={e => setShowOptions(false)}
        ></div>
      )}
      <div className="tagPopupTitle">Organize Your Uploaded Contacts</div>
      <p className="tagPopupSubTitle">
        Add them to a list and apply tags to keep everything structured.
      </p>
      <div
        className="popup-close"
        title="Click here to close"
        onClick={() => closeAction()}
      >
        <i className="material-icons">close</i>
      </div>
    </>
  );
};

export default TagPopupHeader;
export { TagPopupHeader };
